/// <reference path="../../typings/browser.d.ts" />

export const openLayersSID = 'openLayers';
